export default "__VITE_ASSET__B3He50gp__"